/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateMailDto } from '../models/work-create-mail-dto';
import { WorkMail } from '../models/work-mail';
import { WorkUpdateMailDto } from '../models/work-update-mail-dto';

@Injectable({ providedIn: 'root' })
export class WorkMailsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mailsV2ControllerCreate()` */
  static readonly MailsV2ControllerCreatePath = '/v2/mails';

  /**
   * Required permissions: contacts:create, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mailsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailsV2ControllerCreate$Response(
    params: {
      body: WorkCreateMailDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMail>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMailsV2Service.MailsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMail>;
      })
    );
  }

  /**
   * Required permissions: contacts:create, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mailsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailsV2ControllerCreate(
    params: {
      body: WorkCreateMailDto
    },
    context?: HttpContext
  ): Observable<WorkMail> {
    return this.mailsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMail>): WorkMail => r.body)
    );
  }

  /** Path part for operation `mailsV2ControllerDelete()` */
  static readonly MailsV2ControllerDeletePath = '/v2/mails/{id}';

  /**
   * Required permissions: contacts:delete, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mailsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  mailsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMailsV2Service.MailsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: contacts:delete, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mailsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mailsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.mailsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `mailsV2ControllerUpdate()` */
  static readonly MailsV2ControllerUpdatePath = '/v2/mails/{id}';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mailsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMailDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMail>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMailsV2Service.MailsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMail>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mailsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMailDto
    },
    context?: HttpContext
  ): Observable<WorkMail> {
    return this.mailsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMail>): WorkMail => r.body)
    );
  }

}
